__turbopack_context__.v({
  "buttons": "FreeTrialExpired-module__Uu5G4W__buttons",
  "buyPrice": "FreeTrialExpired-module__Uu5G4W__buyPrice",
  "costs": "FreeTrialExpired-module__Uu5G4W__costs",
  "icon": "FreeTrialExpired-module__Uu5G4W__icon",
  "main": "FreeTrialExpired-module__Uu5G4W__main",
  "nominalPrice": "FreeTrialExpired-module__Uu5G4W__nominalPrice",
  "price": "FreeTrialExpired-module__Uu5G4W__price",
  "prices": "FreeTrialExpired-module__Uu5G4W__prices",
});
